import { ReactNode, createContext } from "react";
import { useState, useEffect } from "react";
import localforage from "localforage";

const FloorContext = createContext({
	floor: -1,
	setFloor: (floor: number) => {},
});

type FloorContextProps = {
  children?: ReactNode
};

export const FloorProvider = ({ children }: FloorContextProps) => {

  const [floor, setFloor] = useState<number>(-1);

  useEffect(() => {

    localforage.getItem<string>("FLOOR")
    .then((value: string| null) => {
      if (value !== null) {
        console.log("Retrieved floor:", value);
        setFloor(parseInt(value));
      } else {
        console.log("No value found");
      }
    })
    .catch((err: unknown) => {
      console.error("Error retrieving floor from storage", err);
    });

    /*
    Cache.getItem("FLOOR")
    .then(result => {
      setFloor(parseInt(result));
    })*/ 
    return () => {
    };
  }, []);   

  return (
    <FloorContext.Provider value={{floor, setFloor}}>
      {children}
    </FloorContext.Provider>
  );
};

export default FloorContext;
